export const CHR_GA_EVENTS = {
    FORM_INPUT: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page"
    },
    DOWNLOAD_SAMPLE_REPORT_SELECTED: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "download_sample_report_selected"
    },
    FETCHES_KBB: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "Fetches_KBB",
        eventLabel: ""
    },
    ALLOWS_ENTERING_VIN: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "allows_entering_VIN",
        eventLabel: ""
    },
    VIN_SELECTED: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "VIN_selected",
        eventLabel: "<VIN Value>"
    },
    OPENS_MY_PURCHASES: {
        event: "custom_event",
        eventCategory: "Status_bar",
        eventAction: "opens_my_purchases",
        eventLabel: ""
    },
    OPEN_FAQ_ANSWER: {
        event: "custom_event",
        eventCategory: "landing_page",
        eventAction: "open_faq_answer",
        eventLabel: ""
    },
    KNOW_MORE_POPUP: {
        event: "custom_event",
        eventCategory: "CHR_landing_page"
    },
    OPENS_CHECKOUT_PAGE: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "opens_checkout_page",
        eventLabel: ""
    },
    SEARCH_AGAIN_CLICKED: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "search_again_clicked",
        eventLabel: ""
    },
    ON_PROCEED_TO_REPORT_CLICKED: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "opens_checkout_page",
        eventLabel: ""
    },
    TAKES_USER_BACK_TO_LANDING_PAGE: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "Opens_CHR_landing_page",
        eventLabel: ""
    },
    VARIANT_CHANGES: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "variant_changes",
        eventLabel: ""
    },
    OPENS_MY_PURCHASES_VARIANT: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "opens_my_purchases",
        eventLabel: ""
    },
    SEE_ALL_CHECKS_CLICKED: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "MR_report_popup",
        eventLabel: ""
    },
    OPEN_GRAPH_POPUP: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "Demand_report_popup",
        eventLabel: ""
    },
    ODO_INPUT: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "Odo_selected",
        eventLabel: "ODO_entered"
    },
    ADVERTISE_PRICE_INPUT: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "advertise_price_selected",
        eventLabel: ""
    },
    PROCEED_PAYMENT: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "Payment_page",
        eventLabel: ""
    },
    PAYMENT_SUCCESS_KNOW_MORE: {
        event: "custom_event",
        eventCategory: "Payment_successful_page",
        eventLabel: ""
    },
    PAYMENT_SUCCESS_LOGIN: {
        event: "custom_event",
        eventCategory: "Payment_successful_page",
        eventLabel: ""
    },
    TRANSACTION_FAILED_TRY_AGAIN: {
        event: "custom_event",
        eventCategory: "Transaction_failed_page",
        eventLabel: ""
    },
    GO_TO_MY_ORDERS: {
        event: "custom_event",
        eventCategory: "Payment_successful_page",
        eventLabel: ""
    },
    DOWNLOAD_REPORT: {
        event: "custom_event",
        eventCategory: "my_purchases",
        eventLabel: ""
    },
    CONTACT_SUPPORT: {
        event: "custom_event",
        eventCategory: "my_purchases",
        eventLabel: ""
    },
    CHR_ENTRY_POINT_CLICKED: {
        event: "custom_event",
        eventCategory: "Homepage",
        eventAction: "Opens_CHR_landing_page",
        eventLabel: ""
    },
    PAYMENT_MODE_SELECTED: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "card_selected",
        eventLabel: ""
    },
    PAYMENT_SUCCESS_PAGE_LANDED: {
        event: "custom_event",
        eventCategory: "Payment_successful_page",
        eventAction: "payment_success_page"
    },
    CHR_LANDING_PAGE_LANDED: {
        event: "custom_event",
        eventCategory: "landing_page",
        eventAction: "enters_landing_page"
    },
    CHR_LANDING_VARIANT_SELECTION_PAGE_LANDED: {
        event: "custom_event",
        eventCategory: "variant_selection_page",
        eventAction: "opens_variant_selection_page"
    },
    CHR_CHECKOUT_PAGE_LANDED: {
        event: "custom_event",
        eventCategory: "checkout_page",
        eventAction: "opens_checkout_page"
    },
    CHR_PAYMENT_PAGE_LANDED: {
        event: "custom_event",
        eventCategory: "payment_gateway",
        eventAction: "opens_payment_gateway"
    },
    C2B_FLOW: {
        event: "custom_event",
        eventCategory: "C2B_flow",
        eventAction: "sell_car_banner_clicked"
    },
    CHR_HOME_CARD: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page"
    },
    CHR_SECTION_IMPRESSION: {
        event: "custom_event",
        eventCategory: "Buy_used_cars_CHR",
        eventAction: "Section_impression"
    },
    CHR_BANNER_CLICK: {
        event: "custom_event",
        eventCategory: "Buy_used_cars_CHR",
        eventAction: "banner_click"
    },
    CHR_BANNER_2_REPORT_CLICKED: {
        event: "custom_event",
        eventCategory: "Buy_used_cars_CHR",
        eventAction: "CHR_Banner_2_report_clicked"
    },
    AUTOGRAB_DETAILS: {
        event: "custom_event",
        eventCategory: "autograb_details",
        eventAction: "count_of_ag_id",
        eventLabel: ""
    }
};
